import {UserDataApi} from "../UserDataApi";
import {IQueryOptions, QueryKey, useQueryWrapper} from "./api-hooks-common";

export const useGetUserInfo = (username: string, options?: IQueryOptions) => useQueryWrapper([QueryKey.USER_INFO, username], () => UserDataApi.getDataInfo(username), null, options);
